import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { I18nPipe } from '@bbitgmbh/website.sdk';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  imports: [NgClass, I18nPipe],
})
export class LoadingComponent {
  readonly classes = input(['h-8', 'w-8']);
  readonly hideText = input(false);
  readonly noWhitespace = input(false);
}
